import { render, staticRenderFns } from "./CustomOrderDetails.vue?vue&type=template&id=354b1e92"
import script from "./CustomOrderDetails.vue?vue&type=script&lang=js"
export * from "./CustomOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomOrderDetails.vue?vue&type=style&index=0&id=354b1e92&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports